import { fetchClientToken } from "./fetchClientToken"

interface Stateroom {
  stateroomId: string
  stateroomCategory?: string
  stateroomDeck?: number
  stateroomLocation?: string
  accessible?: boolean
  connectingRoom?: string
  maxOccupancy?: number
  [key: string]: any
}

interface Deck {
  deckNumber: number
  stateroomCount: number
  staterooms: Stateroom[]
  [key: string]: any
}

interface Location {
  locationCount: number
  deckCount: number
  decks: { [key: string]: Deck }
  [key: string]: any
}

interface StateroomSubType {
  stateroomCount: number
  categoryCount?: number
  locationCount?: number
  locations?: { [key: string]: Location }
  [key: string]: any
}

interface StateroomSubTypeGrouping {
  [key: string]: StateroomSubType
}

interface StateroomType {
  stateroomCount: number
  stateroomSubtypes: StateroomSubTypeGrouping
  [key: string]: any
}

export interface StateroomTypeGrouping {
  [key: string]: StateroomType
}

interface VoyagePackage {
  vacEndDate: string
  vacStartDate: string
}

interface Session {
  stateroomTypes: StateroomTypeGrouping
  voyagePackage: VoyagePackage
}

interface Availability {
  sessions: Session[]
}


export async function fetchAvailability(sailing: string): Promise<Availability | undefined> {
  const url = `https://uchmc0u1jb.execute-api.us-east-2.amazonaws.com/dcl-stateroom-availability`

  try {
    const accessToken = await fetchClientToken()
    if (!accessToken) {
      console.error("Failed to fetch access token")
      return undefined
    } 

    const response = await fetch(url, {
      method: "POST",
      mode: "cors",
      headers: {
        'accept': 'application/json, text/plain, */*',
        'accept-encoding': 'gzip, deflate, br',
        'accept-language': 'en-us',
        'content-type': 'application/json',
      },
      body: JSON.stringify({
        'sailing': sailing,
        'accessToken': accessToken,
      })
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const data = await response.json()
    return data as Availability
  } catch (error) {
    console.log(error)
    return undefined
  }
}
